import { split, reject, isEmpty } from 'ramda'

export const getWuid = (pathname: string) => {
  const paths = reject(isEmpty, split('/', pathname))

  return paths[0] === 'wedding' && paths[1] !== 'create' ? paths[1] : undefined
}
